import Constant from '@/const';
import axios from 'axios';

const getPatientRegistrationById = async idRegistration => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/registration/${idRegistration}`),
    );
    return response.data.data;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getPatientRegistrationById;
